import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const c = {
  cream: "#FFF8F0",
  kraft: "#F5E6D0",
  kraftDark: "#E8D5B8",
  flamenco500: "#F05260",
  flamenco400: "#F47781",
  flamenco300: "#F6A2A9",
  flamenco100: "#F7D9DC",
  skyfall500: "#84D5F7",
  skyfall400: "#99DDF9",
  skyfall100: "#CBEFFF",
  mintleaf500: "#4EB969",
  mintleaf400: "#69CB82",
  mintleaf300: "#91DFA5",
  plumwood500: "#842885",
  plumwood400: "#B666B7",
  plumwood300: "#EA9BEB",
  white: "#FFFFFF",
  darkText: "#3B2314",
  medText: "#6B4D3A",
};

export const nav: NavPalette = {
  surface: "rgba(255, 248, 240, 0.94)",
  surfaceHover: "rgba(245, 230, 208, 0.96)",
  border: "rgba(107, 77, 58, 0.3)",
  text: "#3B2314",
  textMuted: "rgba(107, 77, 58, 0.75)",
  activeBg: "rgba(232, 213, 184, 0.7)",
  activeText: "#3B2314",
};
